import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Ed forms
   */
  {
    label:
      'Do you have a current prescription for Viagra (sildenafil) or Cialis (tadalafil)?',
    field: 'ed1',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'prescriptionYes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'prescriptionDesc',
            placeholder:
              'Which medication, what dose, how you take it, how effective is it?'
          }
        },
        {
          key: 'prescriptionNo',
          value: 'No',
          answer: {
            type: 'radio',
            name: 'taken',
            label: 'Ever taken Viagra or Cialis',
            options: [
              {
                key: 'yes',
                value: 'Yes',
                answer: {
                  type: 'text',
                  name: 'takenDesc',
                  placeholder: 'What was the dose and what was your response?'
                }
              },
              { key: 'no', value: 'No' }
            ]
          }
        }
      ]
    }
  },
  {
    label: 'Describe your issue with sexual functioning?',
    field: 'ed2',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'forming', value: 'No medical issues', uncheckOthers: true },
        { key: 'maintaining', value: 'Difficulty maintaining erection' },
        { key: 'early', value: 'Ejaculating too early' },
        { key: 'low', value: 'Low libido or sexual desire' }
      ],
      fullWidth: true
    }
  },
  {
    field: 'ed3',
    label: 'When was the last time you had a morning erection?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'lastMorning_less3', value: '3 Months Ago' },
        { key: 'lastMorning_3to6', value: '3 - 6 Months Ago' },
        { key: 'lastMorning_more6', value: '6 Months Ago' },
        { key: 'lastMorning_never', value: 'never' }
      ]
    }
  },
  {
    field: 'ed33',
    label: 'When was the last time you had normal sexual functioning?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'lastNormal_less3', value: '3 Months Ago' },
        { key: 'lastNormal_3to6', value: '3 - 6 Months Ago' },
        { key: 'lastNormal_more6', value: '6 Months Ago' }
      ]
    }
  },
  {
    field: 'ed4',
    label:
      'Do you take medication for any of the following medical conditions?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'noMedicationsForConditions', value: 'No', uncheckOthers: true },
        {
          key: 'diabetes',
          value: 'Diabetes',
          answer: {
            type: 'radio',
            name: 'diabetesHba1cReading',
            label: 'What was your last HbA1c reading?',
            options: [
              { key: '5to6', value: '5 to 6' },
              { key: '6to7', value: '6 to 7' },
              { key: '7to8', value: '7 to 8' },
              { key: '8to9', value: '8 to 9' },
              { key: 'moreThan9', value: 'more than 9' }
            ]
          }
        },
        {
          key: 'hypertension',
          value: 'High blood pressure',
          answer: {
            type: 'hypertension',
            label: 'What was your last blood pressure reading?',
            title: {
              value: 'Systolic (top&nbsp;number)',
              unit: 'Diastolic (bottom&nbsp;number)'
            },
            measure: {
              type: 'measure',
              value: {
                type: 'dropdown',
                name: 'hypertensionReadingHigh',
                options: [
                  { key: '80-90', value: '80-90' },
                  { key: '91-100', value: '91-100' },
                  { key: '101-110', value: '101-110' },
                  { key: '111-120', value: '111-120' },
                  { key: '121-130', value: '121-130' },
                  { key: '131-140', value: '131-140' },
                  { key: '141-150', value: '141-150' },
                  { key: '151-160', value: '151-160' },
                  { key: '161-170', value: '161-170' },
                  { key: '171-180', value: '171-180' },
                  { key: '181-190', value: '181-190' },
                  { key: '191-200', value: '191-200' }
                ],
                placeholder: '120',
                size: 'large'
              },
              division: '/',
              unit: {
                type: 'dropdown',
                name: 'hypertensionReadingLow',
                options: [
                  { key: '50-55', value: '50-55' },
                  { key: '56-60', value: '56-60' },
                  { key: '61-65', value: '61-65' },
                  { key: '66-70', value: '66-70' },
                  { key: '71-75', value: '71-75' },
                  { key: '76-80', value: '76-80' },
                  { key: '81-85', value: '81-85' },
                  { key: '86-90', value: '86-90' },
                  { key: '91-95', value: '91-95' },
                  { key: '96-100', value: '96-100' },
                  { key: '101-105', value: '101-105' }
                ],
                placeholder: '80',
                size: 'large'
              }
            }
          }
        }
      ],
      fullWidth: true
    }
  },
  {
    field: 'ed5',
    label:
      'Have you ever been told your blood pressure is too high or too low?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pressureTooYes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'pressureTooDesc',
            placeholder: 'Please describe'
          }
        },
        { key: 'pressureTooNo', value: 'No' }
      ]
    }
  },
  {
    field: 'ed55',
    label:
      'Have you had any surgery, injury, nerves issue or deformity to your penis which affected your sexual functioning?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'injuryYes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'injuryDesc',
            placeholder: 'Please describe'
          }
        },
        { key: 'injuryNo', value: 'No' }
      ]
    }
  },
  {
    field: 'ed6',
    label: 'Do you feel healthy enough to have sex?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'healthy',
          value: 'Yes, I have no health problems'
        },
        {
          key: 'some',
          value: 'Yes, I have some health problems but sex is fine'
        },
        { key: 'unhealthy', value: 'No, I am too unhealthy for sex' }
      ]
    }
  },
  {
    field: 'ed66',
    label: 'What do you feel is causing your issue with sexual functioning?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'feelDesc',
      placeholder: 'Please describe'
    }
  },
  {
    field: 'ed7',
    label: 'How many times/month are you sexually active?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'monthlyActivity'
    }
  },
  {
    field: 'ed8',
    label:
      'If you were not hindered by ED, how many times/month would you want to be sexually active?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'wantedMonthlyActivity'
    }
  },
  {
    field: 'ed9',
    educationalSlide:'We offer the following products for erectile dysfunction. \n\n We have on demand products ( Tadalafil, Sildenafil ) and daily products ( Tadalafil Daily ). \n\n Dosing is based on any previous products or dosages you have had before, your current medical history & age and discretion of the medical team. \n\n Sildenafil on demand \n\n- Starting at $8.97 per dose \n\n- Sildenafil typically works in half an hour and lasts around 4 hours.\n\n- You can take one tablet every 24 hours \n\n Tadalafil on demand \n\n- Starting at $10.80 per dose\n\n- Tadalafil typically works within an hour and can last up to 36 hours\n\n- You can take one tablet every 36 hours\n\nTadalafil daily \n- Starting at $3.10 per dose\n- Tadalafil works within one hour and lasts around 24 hours.\n\n- It is taken every day (every 24 hours).',
    label: '',
    sublabel:'',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'speakToMedical',
          value: 'I would like to speak to the medical team about which medication is best for me'
        },
        {
          key: 'goodToGo',
          value: 'I’m ready to start the medication I ordered!'
        }
      ]
    }
  },
  {
    label: 'How\'s your lasting time during a sexual interaction?',
    field: 'ed10',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less1min', value: 'Less than 1 minute'},
        { key: '1-3min', value: '1-3 minutes' },
        { key: '4-6min', value: '4-6 minutes' },
        { key: '7-9min', value: '7-9 minutes' },
        { key: '10min', value: '10+ minutes' }
      ],
    }
  },
  {
    label: 'How long would you like to last during a sexual interaction?',
    field: 'ed11',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1-3min', value: '1-3 minutes' },
        { key: '4-6min', value: '4-6 minutes' },
        { key: '7-8min', value: '7-9 minutes' },
        { key: '10min', value: '10+ minutes' }
      ],
    }
  },
  {
    field: 'ed12',
    label:
      'I agree to have my relevant prescription information transferred to IHS Compounding Pharmacy. The information shared will be kept strictly confidential in accordance with the Ontario College of Pharmacists` regulations.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [{ key: 'edAcknowledgement', value: 'I Agree' }]
    }
  },

  //Jaxx Questions

  {
    label: 'Please select the dose of JaXX you are using',
    field: 'jaxx1',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'sil25tada2.5', value: 'sildenafil 25mg/tadalafil 2.5mg'},
        { key: 'sil25tada5', value: 'sildenafil 25mg/tadalafil 5mg' },
        { key: 'sil50tada5', value: 'sildenafil 50mg/tadalafil 5mg' },
        { key: 'sil50tada8', value: 'sildenafil 50mg/tadalafil 8mg' },
        { key: 'sil50tada12', value: 'sildenafil 50mg/tadalafil 12mg' },
        { key: 'cantremember', value: 'I can`t remember' }
      ],
    }
  },
  {
    label: 'Have you experienced any of the following side effects? (Check all that apply)',
    field: 'jaxx2',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'runnynose', value: 'runny nose or congestion'},
        { key: 'headache', value: 'headache' },
        { key: 'dizziness', value: 'dizziness' },
        { key: 'lightheadedness', value: 'lightheadedness' },
        { key: 'palpitation', value: 'palpitation (fast heartbeat)' },
        { key: 'flushing', value: 'flushing' },
        { key: 'blurredvision', value: 'blurred vision' },
        { key: 'nausea', value: 'nausea' },
        { key: 'diarrhea', value: 'diarrhea' },
        { key: 'priapism', value: 'priapism (erection lasting 4 hours or more)' },
        { key: 'swelling', value: 'swelling' },
        { key: 'itchiness', value: 'itchiness' },
        { key: 'allergic', value: 'allergic reaction' },
        {
          key: 'none',
          value: 'None of the above',
          uncheckOthers: true
        }
      ],
    }
  },
  {
    label: 'How would you rate your experience with JaXX?',
    field: 'jaxx3',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'great', value: 'It is working great for me'},
        { key: 'asEd', value: 'It is working as well as previous ED drugs I`ve tried' },
        { key: 'less', value: 'It is working less effectively that other ED drugs I`ve tried' },
        { key: 'notworking', value: 'It is not working well for me ' },
        { key: 'notSure', value: 'I am not sure how to know if the medication is working for me' },
      ],
    }
  },
  {
    label: 'How would you rate the strength of the medication?',
    field: 'jaxx4',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'right', value: 'It is the right strength for me'},
        { key: 'notstrong', value: 'It is not strong enough for me' },
        
      ],
    }
  },
  {
    label: 'How you would rate the duration of the medication (how long does it last?)',
    field: 'jaxx5',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '4less', value: '4 hours or less'},
        { key: '4to12', value: '4-12 hours' },
        { key: '12to24', value: '12-24 hours' },

        { key: '24-36', value: '24-36 hours' },

        { key: '36plus', value: '36+  hours' },

        
      ],
    }
  },
  {
    // 5
    field: 'jaxx6',
    label: 'If you can, provide some specific details of your experience. (Relative strength of the medication to other medications you have tried, relative duration of the medication etc.)',
    type: 'info',
    answer: {
    type: 'text',
    name: 'jaxxexperience'
    }
  },
];

export default questionsModels;
